export type FooterTranslation = {
  contact: string;
  privacyPolicy: string;
  termsConditions: string;
};

export const footerTranslation: FooterTranslation = {
  contact: 'Contact',
  privacyPolicy: 'Privacy Policy',
  termsConditions: 'Terms and Conditions',
};
